import React, {useState} from 'react';
import ReactPlayer from 'react-player';
//import {useBreakpoint} from "../../libs/breakpoint";
//import Icon from "./Icon";
import _ from "lodash";
import {Can} from "../../ability-context";
import ModalSubscription from "./ModalSubscription";
import {USER_CURRENT_KEY} from "../../api/public-voissa/users";
import {useQueryClient} from "@tanstack/react-query";

import createLink from "../../libs/createLink";

import iconSvgVideoLocked from "../../images/video_locked.svg";
import Modal from "./Modal";
import {useBreakpoint} from "../../libs/breakpoint";

const PlayerArchive = ({
        isCurrentUser = false,
        isNew = false
    }) =>{
    const [toggleSubscription, setToggleSubscription] = useState(false);
    const breakpoints = useBreakpoint();
    return (
        <div className={"player-archive"}>
            <Modal toggle={toggleSubscription}
                   handleClose={() => setToggleSubscription(false)}>
                <ModalSubscription  handleClose={() => setToggleSubscription(false)} isArchived={true} />
            </Modal>
            <div className={"player-archive-content"}>
                <div className={"player-icon"}><img src={iconSvgVideoLocked} alt={""} /> </div>
                {isCurrentUser ? (
                    <>
                        <div className={"player-text h1"}>Consultez intégralement les vidéos<br />de {isNew ? "moins de 24h" : "plus d’un mois"} avec l’option premium.</div>
                        <div className={"player-footer"}>
                            <div className="offer-cta" onClick={() => setToggleSubscription(true)} >
                                OFFRE PREMIUM
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={`player-text h1`}>Les vidéos de {isNew ? "moins de 24h" : "plus d'un mois"}{breakpoints.sm ? <br /> : " "}sont réservées aux membres.</div>
                        <div className={"player-footer"}>
                            <a className="signup-cta" href={createLink("signup")+"#nodisclaimer"} >
                                <div className="line1">Inscription</div>
                                <div className="line2">(c'est gratuit)</div>
                            </a>
                            <a className={"signin-cta"} href={createLink("signin")+"#nodisclaimer"} >Connexion</a>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

const PlayerTimeline = () =>{

    const breakpoints = useBreakpoint();
    return (
        <div className={"player-archive"}>

            <div className={"player-archive-content"}>
                <div className={"player-icon"}><img src={iconSvgVideoLocked} alt={""} /> </div>
                    <div className={`player-text h1`}>Les vidéos présentant des actes sexuels{breakpoints.sm ? <br /> : " "}sont réservées aux membres.</div>
                    <div className={"player-footer"}>
                        <a className="signup-cta" href={createLink("signup")+"#nodisclaimer"} >
                            <div className="line1">Inscription</div>
                            <div className="line2">(c'est gratuit)</div>
                        </a>
                        <a className={"signin-cta"} href={createLink("signin")+"#nodisclaimer"} >Connexion </a>
                    </div>
            </div>
        </div>
    )
}

class PlayerContent extends React.Component {
    constructor(props) {
        super(props);
        let volume = _.toNumber(localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_volume`) || 0.5);
        let muted = this.props.muteStrength ? true : localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_muted`) === "true" ? true : false;
        this.state = {
            volume,
            muted,
            controls : this.props.controls,
            isLockPlayer : false,
            isBlurPlayer : false,
            subscription : this.props.isLockPlayer
        }
        this.internalPlayer = null;
        this.onReady = this.onReady.bind(this);
        this.handleLimiting = this.handleLimiting.bind(this);
    }


    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.preview !== nextProps.preview){
            return true;
        }
        if(this.props.playing !== nextProps.playing){
            return true;
        }
        if(this.state.controls !== nextState.controls){
            return true;
        }
        if(this.state.isLockPlayer !== nextState.isLockPlayer){
            return true;
        }
        if(this.state.isBlurPlayer !== nextState.isBlurPlayer){
            return true;
        }
        if(this.state.subscription !== nextState.subscription){
            return true;
        }


        return false;
    }

    componentWillUnmount() {
        try{
            if(this.internalPlayer){
                this.internalPlayer.removeEventListener('volumechange', this.onVolumeChange);
                if(!this.props.isClickRight) {
                    this.internalPlayer.removeEventListener('contextmenu', this.contextMenu);
                }
                this.internalPlayer.pause();
            }
        }catch (e){
            console.log(e);
        };

    }

    onReady = (player) => {
        try {
            this.internalPlayer = player.getInternalPlayer();
            this.internalPlayer.addEventListener('volumechange', this.onVolumeChange);

            if(!this.props.isClickRight) {
                this.internalPlayer.addEventListener("contextmenu", this.contextMenu);
            }
            //this.internalPlayer.addEventListener("contextmenu", (e) => {e.preventDefault()});
            this.props.setRefPlayer(this.internalPlayer);

        } catch (e) {
            console.log(e);
        }
    }

    onError = (event) => {
        try {
            if(!this.props.isClickRight){
                event?.target?.addEventListener("contextmenu", this.contextMenu);
            }

            //player.addEventListener("contextmenu", (e) => {e.preventDefault()});
        } catch (e) {
            console.log(e);
        }
    }


    onVolumeChange = (event) => {
        let {volume = 0.5, muted = false} = event.target;
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_volume`, volume);
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_muted`, muted);
        this.setState({ volume, muted });
    }

    handleLimiting = (data) => {
        if(this.props.limitDuration !== 0 && data.playedSeconds >= this.props.limitDuration){
            if(this.props.isLockPlayer){
                let isLockPlayer = this.props.isLockPlayer || this.state.isLockPlayer;
                this.setState({controls : false, isLockPlayer});
                this.internalPlayer.pause();
            }
            if(this.props.isBlurPlayer){
                let isBlurPlayer = this.props.isBlurPlayer || this.state.isBlurPlayer;


                if(!!document.fullscreenElement || !!document.webkitFullscreenElement){
                    //if (document.fullscreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.webkitDisplayingFullscreen) {
                    //alert("exite fullscreen");
                    document.webkitExitFullscreen();
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                        document.webkitExitFullscreen();
                    }
                    else if (document.msExitFullscreen) { /* IE/Edge */
                        document.msExitFullscreen();
                    }
                    //}
                }

                this.setState({controls : false, isBlurPlayer});


            }

            /*if (document.fullscreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.webkitDisplayingFullscreen) {
            //alert("exite fullscreen");
            if (document.exitFullscreen)
                 document.exitFullscreen();
             else if (document.webkitExitFullscreen)
                 document.webkitExitFullscreen();
             else if (document.mozCancelFullScreen)
                 document.mozCancelFullScreen();
             else if (document.msExitFullscreen)
                 document.msExitFullscreen();
            }*/

            let element = document.getElementById(`player-${_.get(this.props,'media._id') || "error"}`);
            element.className += " player-blur";
        }
    }

    contextMenu = (e) => {
        e.preventDefault();
    }


    render () {
        let {media = {}, playsinline = true, isCurrentUser = false, isNew = false, isArchived = false, light = null, playing = true, width='100%', height="100%", style ={}} = this.props;

        return (
            <>
                <ReactPlayer
                    key={media._id}
                    id={`player-${media._id || "error"}`}
                    playing={playing}
                    url={media.urlVideo}
                    light={light}
                    onReady={this.onReady}
                    onError={this.onError}
                    volume={this.state.volume}
                    muted={this.state.muted}
                    className={`react-player`}
                    width={width}
                    height={height}
                    controls={this.state.controls}
                    onProgress={this.handleLimiting}
                    playsinline={playsinline}
                    style={style}
                    //playIcon={<Icon type="play" className={"big-player"} />}
                    config={
                        {
                            file: {
                                attributes: {
                                    controlsList: 'nodownload'
                                }
                            }
                        }
                    }
                />

            {this.state.isLockPlayer ?
                <PlayerArchive isCurrentUser={isCurrentUser} isArchived={isArchived} isNew={isNew} />
            : null
            }
            {!this.props.isLockPlayer && this.state.isBlurPlayer ?
                <PlayerTimeline  />
                : null
            }
        </>
        )
    }
}

const Player = ({
        media = {},
        controls = true,
        playsinline = true,
        muteStrength = false,
        setRefPlayer = () =>{},
        ...props
    }) => {


    const queryClient = useQueryClient();
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    //let preview = (Array.isArray(media.screenshotsOrder) && !!media.screenshotsOrder.length) ? media.previewUrl[media.screenshotsOrder[0]] : media.previewUrl[0];
    let preview = media.videoCoverUrl;
    let {videoUrlFormat = {}} = media;
    
    let urlVideo = videoUrlFormat.hd || videoUrlFormat.sd;
    /*if(breakpoints.md ){
        urlVideo = videoUrlFormat.sd;
    }*/
    /*if(media._id.toString() === "6205f505169bb902f19899b8"){
        urlVideo = "http://www.rigarudy.com/hd.mp4";
    }*/
    //urlVideo = "http://www.rigarudy.com/hd.mp4";

    media = {
        ...media,
        preview,
        urlVideo
    }

    let limitDuration = _.get(media,'abTestingAction.maxTime') || 0;
    let isLockPlayer = _.get(media,'abTestingAction.isLock') || false;
    let isBlurPlayer = _.get(media,'abTestingAction.isBlur') || false;
    let isArchived = _.get(media,'abTestingAction.isArchived') || false;
    let isNew = _.get(media,'abTestingAction.isNew') || false;

    return <Can action="clickRight" subject="Media" passThrough>
        {can => {
            return (
                <PlayerContent
                    key={media._id}
                    isClickRight={can}
                    limitDuration={limitDuration}
                    isLockPlayer={isLockPlayer}
                    media={media}
                    playsinline={playsinline}
                    setRefPlayer={setRefPlayer}
                    controls={controls}
                    muteStrength={muteStrength}
                    isCurrentUser={isCurrentUser}
                    isArchived={isArchived}
                    isNew={isNew}
                    isBlurPlayer={isBlurPlayer}
                    {...props}
                />);
        }}
        </Can>
}

export default Player;
